import * as React from "react";
import { AreaOnlySeries } from "./AreaOnlySeries";
import { LineSeries } from "./LineSeries";
export class BollingerSeries extends React.Component {
    constructor() {
        super(...arguments);
        this.yAccessorForScaledBottom = (scale, d) => {
            const { yAccessor = BollingerSeries.defaultProps.yAccessor } = this.props;
            const bb = yAccessor(d);
            if (bb === undefined) {
                return undefined;
            }
            return scale(bb.bottom);
        };
        this.yAccessorForBottom = (d) => {
            const { yAccessor = BollingerSeries.defaultProps.yAccessor } = this.props;
            const bb = yAccessor(d);
            if (bb === undefined) {
                return undefined;
            }
            return bb.bottom;
        };
        this.yAccessorForMiddle = (d) => {
            const { yAccessor = BollingerSeries.defaultProps.yAccessor } = this.props;
            const bb = yAccessor(d);
            if (bb === undefined) {
                return undefined;
            }
            return bb.middle;
        };
        this.yAccessorForTop = (d) => {
            const { yAccessor = BollingerSeries.defaultProps.yAccessor } = this.props;
            const bb = yAccessor(d);
            if (bb === undefined) {
                return undefined;
            }
            return bb.top;
        };
    }
    render() {
        const { className, strokeStyle = BollingerSeries.defaultProps.strokeStyle, fillStyle } = this.props;
        return (React.createElement("g", { className: className },
            React.createElement(LineSeries, { yAccessor: this.yAccessorForTop, strokeStyle: strokeStyle.top }),
            React.createElement(LineSeries, { yAccessor: this.yAccessorForMiddle, strokeStyle: strokeStyle.middle }),
            React.createElement(LineSeries, { yAccessor: this.yAccessorForBottom, strokeStyle: strokeStyle.bottom }),
            React.createElement(AreaOnlySeries, { yAccessor: this.yAccessorForTop, base: this.yAccessorForScaledBottom, fillStyle: fillStyle })));
    }
}
BollingerSeries.defaultProps = {
    areaClassName: "react-financial-charts-bollinger-band-series-area",
    fillStyle: "rgba(38, 166, 153, 0.05)",
    strokeStyle: {
        top: "#26a69a",
        middle: "#812828",
        bottom: "#26a69a",
    },
    yAccessor: (data) => data.bb,
};
//# sourceMappingURL=BollingerSeries.js.map